import { useEffect } from "react";

/**
 * Resets pagination to page 1 when any value in filterDeps changes.
 * Do not include pageNumber in filterDeps.
 */
export default function useResetPageOnFilterChange(setPageNumber, filterDeps) {
  useEffect(() => {
    setPageNumber(1);
    // filterDeps is the intended trigger list; setState setter is stable
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, filterDeps);
}
